import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/transaction-accounts.js';
import q from '../query.js';
export const transactionAccountsEntity = 'transaction-accounts';
const allTransactionAccountsKey = () => `all-transaction-accounts`;
export const useTransactionAccounts = () => q.query(allTransactionAccountsKey(), () => api.getAll(), keys.read.collection(transactionAccountsEntity));
const transactionImportKey = (id) => `transaction-import-${id}`;
export const useTransactionImport = (id) => q.query(transactionImportKey(id), () => api.getImportById(id), keys.read.item(transactionAccountsEntity, id), { enabled: id != null });
//# sourceMappingURL=index.js.map